import { Typography } from '@material-ui/core'
import React, { useContext } from 'react'
import TranslationLabel, {
  translationLink,
} from '../components/TranslationLabel'
import { CoreContext } from '../context/CoreContext'

export default function HubHelpPage() {
  const core = useContext(CoreContext)
  const internalRDGUserTypes = [1, 2, 5, 7]
  const userIsRDGInternal = internalRDGUserTypes.includes(
    core.user.userSetting.userTypeId,
  )

  const publicLinks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
  const internalLinks = [1, 2, 3, 4]

  return (
    <>
      <Typography
        variant='h5'
        component='h1'>
        <TranslationLabel name='hubHelpPageTitle' />
      </Typography>
      {userIsRDGInternal && (
        <div style={{ marginTop: 20 }}>
          <Typography variant='subtitle1'>
            <TranslationLabel name='internalHubLinks' />
          </Typography>
          {internalLinks.map((el) => (
            <HelpLink
              linkName={'internalHubHelpLink' + el}
              key={'internalHubHelp' + el}
            />
          ))}
        </div>
      )}
      <div style={{ marginTop: 20 }}>
        <Typography variant='subtitle1'>
          <TranslationLabel name='hubHelpLinks' />
        </Typography>
        {publicLinks.map((el) => (
          <HelpLink
            linkName={'hubHelpLink' + el}
            key={'hubHelpLink' + el}
          />
        ))}
      </div>
    </>
  )
}

const HelpLink = (props) => {
  const { linkName } = props
  const core = useContext(CoreContext)

  const { isEditMode } = core.dictionary

  const value = core.dictionary.getLabel(linkName)

  return isEditMode || value.toLowerCase() !== 'ikke i brug' ? (
    <Typography
      style={{
        color: 'blue',
        textDecoration: 'underline',
        marginTop: 5,
        marginBottom: 5,
      }}
      variant='subtitle1'>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={translationLink(core.dictionary, linkName)}>
        <TranslationLabel
          name={linkName}
          type='link'
        />
      </a>
    </Typography>
  ) : null
}
